import { render, staticRenderFns } from "./BuildMetrics.vue?vue&type=template&id=74a63971&scoped=true&"
import script from "./BuildMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./BuildMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BuildMetrics.vue?vue&type=style&index=0&id=74a63971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a63971",
  null
  
)

export default component.exports